export const isNameError = (name) => {
  if (name?.length < 2) {
    return true;
  }
  return false;
};

export const isArrayError = (arr) => {
  if (arr?.length > 0) {
    return false;
  }
  return true;
};

// Added isValidName, backwards check compared to other input validations
export const isValidName = (name) => {
  if (!name) return false;
  if (name.length < 2) return false;
  return true;
};

export function isValidEmail(email) {
  // Regular expression pattern for email validation
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

export function isValidPhoneNumber(phoneNumber) {
  // if(phoneNumber === undefined || phoneNumber === null || phoneNumber === "") return true;
  // Regular expression pattern for phone number validation
  const phonePattern = /^(\d{10}|\(\d{3}\) \d{3}-\d{4})$/; // Supports both 10-digit and (XXX) XXX-XXXX formats
  return phonePattern.test(phoneNumber);
}

export const isAgeError = (age) => {
  if (!age || age < 0) {
    return true;
  }
  return false;
};

export const isFieldWithLengthError = (field, length) => {
  if (!field || !length) {
    return true;
  } else if (field.length != length) {
    return true;
  }
  return false;
};

export const isFieldError = (field) => {
  if (!field) {
    return true;
  }
  return false;
};

export const isFieldArrayError = (field) => {
  if (!field || field.length === 0) {
    return true;
  }
  return false;
};

export function isValidPostalCode(postalCode) {
  if(postalCode === undefined || postalCode === null || postalCode === "") return true;
  // Regular expression pattern for US postal code validation
  if (!postalCode) {
    return true;
  }
  const usPostalPattern = /^\d{5}(-\d{4})?$/;

  // Regular expression pattern for Canada postal code validation
  /* Postal codes in canada do not include 
    D, F, I, O, Q or U
  They never START with characters that might be mistaken for numbers:
    I, O, Q, U, W, Z
  But they can include W and Z, just not in position 1
  Regex to include upper and lowercase chars, even though value sets them to uppercase no matter what.
  */
  const canadaPostalPattern = /^[ABCEGHJ-NPRSTVXYabceghj-nprstvxy]\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z][ -]?\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z]\d$/;
      
  return (canadaPostalPattern.test(postalCode));
}

export function isValidDateOfBirth(dateString) {
  // Create a new Date object from the input dateString
  const dob = new Date(dateString);
  if (dob === "Invalid Date") return false;
  // Get the current date
  const currentDate = new Date();

  // Compare the DOB with the current date
  return dob <= currentDate;
}

export function isValidExpiryDate(dateString) {
  const expiry = toDate(dateString);
  if (!expiry) return false;
  // Normalize both dates to UTC midnight (treat values as date-only)
  const normalizedExpiry = new Date(expiry.getTime());
  normalizedExpiry.setUTCHours(0, 0, 0, 0);

  const currentDate = new Date();
  currentDate.setUTCHours(0, 0, 0, 0);

  return normalizedExpiry >= currentDate;
}

export function formatYYYYMMDD(d) {
  const date = toDate(d);
  if (!date) return null;
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}


export function formatEnCA(d) {
  // Return a date-only string in YYYY-MM-DD using UTC components
  const date = toDate(d);
  if (!date) return null;
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function toDate(value) {
  // Accept Date or string; return Date or null
  if (!value) return null;
  const d = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export const isHealthCareError = (value) => {
  // Remove non-numeric characters
  const numericValue = value.replace(/\D/g, "");

  if (numericValue.length !== 10 && !/^(\d{4}-\d{3}-\d{3})$/.test(value)) {
    return true;
  }

  return false;
};

export const isVersionCodeError = (value) => {
  if (!value) {
    return true;
  }
  const letterRegex = /^[a-zA-Z]+$/;
  if (!letterRegex.test(value)) {
    return true;
  }

  return false;
};

export const isValidVigilanceSelection = (item) => {
  if ((item?.id || item?.identified || item?.value)) {
    return true;
  }
  return false;
};
